'use client';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { Button } from '../ui/button';

import { GoArrowDown } from 'react-icons/go';

export function BlogScrollButton() {
  const { t } = useTranslations();

  const scrollDown = () => {
    window.scrollTo({
      top: 500,
      behavior: 'smooth',
    });
  };

  return (
    <div
      onClick={scrollDown}
      className="relative z-10 flex cursor-pointer items-center justify-center gap-4"
    >
      <Button type="button" size={'icon'} variant={'alternative-alt'} aria-label={t('text2370')}>
        <GoArrowDown size={20} />
      </Button>
      <p className="whitespace-nowrap text-sm font-normal tracking-tight text-white lg:text-base">
        {t('text2370')}
      </p>
    </div>
  );
}
